<template>
    <footer>
        <md-toolbar md-elevation="0" class="md-layout md-alignment-center md-dense">
            <span>Copyright © JON Inc. All Rights Reserved.</span>
        </md-toolbar>
    </footer>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>

<style lang="scss" scoped>
    .ie-browser {
        .md-dense {
            height: 48px;
        }
    }
</style>
